import {MainRequest} from 'Services/common';

const UrlMap = {
    list: '/aichat/agent',
    detail: '/aichat/agent/get',
    edit: '/aichat/agent/save',
    remove: '/aichat/agent/delete',
};

export namespace Agent {
    export type QueryForm = {};

    interface Schema {
        name: string; //        智能体名称
        customerId: string; //        租户ID，标识所属租户
        code: string; //        智能体编码，唯一标识
        model: string; //        使用的模型
        description?: string; //        智能体描述
        systemPrompt?: string; //        系统提示词
        temperature?: number; //        温度参数
        maxTokens?: number; //        最大token数
        ragflowSimilarityThreshold?: number; //        RAGFlow相似度阈值（0-1之间）
        ragflowTopK?: number; //        RAGFlow返回结果数量
        ragflowRerankId?: string; //        RAGFlow重排序模型ID
        ragflowUseKg?: boolean; //        是否使用知识图谱：0-否，1-是
        status: boolean; //        状态：0-禁用，1-启用
    }

    export interface List extends Schema {
        id: string;
    }

    export interface Detail extends Schema {
        id: string;
    }

    export interface Form extends Schema {
        id?: string;
    }

    export type QueryList = QueryForm;
}

export class Agent {
    static async list(data: Agent.QueryList) {
        return await MainRequest.post<SuccessData<Agent.List[]>>(
            UrlMap.list,
            data,
        )
            .then(res => res.data.data)
            .then(res => {
                return {
                    total: res?.length,
                    data: res,
                };
            });
    }

    static async detail(id: string) {
        return MainRequest.get<SuccessData<Agent.Detail>>(
            `${UrlMap.detail}/${id}`,
        ).then(res => res.data.data);
    }

    static async save(data: Agent.Form) {
        return MainRequest.post(UrlMap.edit, data);
    }

    static async remove(id: string) {
        return MainRequest.get(`${UrlMap.remove}/${id}`);
    }
}
